import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['toggler', 'container', 'areaCodeSelect', 'destroyField'];
  static values = { newForm: { type: Boolean, default: true } };

  async connect() {
    // The area-code select is only rendered when a fax number request exists. When the org has
    // no request yet, the container is still visible but the target is absent, so guard before use.
    if (!this.hasAreaCodeSelectTarget) return;

    await customElements.whenDefined('awc-autocomplete');
    // Required only while the new/edit fax-number fields container is visible.
    this.areaCodeSelectTarget.required = !this.containerTarget.hidden;
  }

  toggle() {
    if (this.containerTarget.hidden) {
      this.containerTarget.hidden = false;
      this.areaCodeRequired = true;
      if (this.newFormValue) {
        // Remove the `_destroy` field's value.
        this.destroyFieldValue = null;
      }
    } else {
      this.containerTarget.hidden = true;
      if (!this.hasAreaCodeSelectTarget) return;
      this.areaCodeRequired = false;
      if (this.newFormValue) {
        // Only clear select field if it is a new form.
        this.areaCodeSelectTarget.clear();
        // We also need to set the `_destroy` field's value.
        this.destroyFieldValue = '1';
      }
    }
  }

  set areaCodeRequired(value) {
    if (this.hasAreaCodeSelectTarget) {
      this.areaCodeSelectTarget.required = value;
    }
  }

  set destroyFieldValue(value) {
    if (!this.hasDestroyFieldTarget) return;
    const lastField = this.destroyFieldTargets[this.destroyFieldTargets.length - 1];
    if (!value) {
      lastField.removeAttribute('value');
      return;
    }

    lastField.value = value;
  }
}
